export default "__VITE_ASSET__BljoMob8__"